module.exports = __webpack_public_path__ + "img/right-tree.f0a6091b.svg";